import React from 'react'
import PropTypes from 'prop-types'
import { Path, Svg } from '@react-pdf/renderer'

const Nutrition = ({ color }) => {
  return (
    <Svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3.99999 10.6079C3.00833 10.6079 2.16739 10.2628 1.47719 9.57259C0.786995 8.88239 0.441895 8.04146 0.441895 7.04979C0.441895 6.27186 0.672661 5.56953 1.13419 4.94279C1.59619 4.31559 2.19656 3.88533 2.93529 3.65199C2.77009 3.61279 2.60723 3.55189 2.44669 3.46929C2.28663 3.38669 2.14336 3.28239 2.01689 3.15639C1.73456 2.87406 1.55209 2.53619 1.46949 2.14279C1.38689 1.74893 1.36029 1.35273 1.38969 0.954194C1.78823 0.914994 2.18186 0.939261 2.5706 1.02699C2.95979 1.11426 3.29043 1.29416 3.56249 1.56669C3.71789 1.71229 3.84179 1.88239 3.9342 2.07699C4.0266 2.27113 4.09239 2.47529 4.13159 2.68949C4.23846 2.50469 4.35023 2.32246 4.46689 2.14279C4.58356 1.96266 4.72449 1.78999 4.88969 1.62479C4.96763 1.53706 5.05746 1.49086 5.15919 1.48619C5.26139 1.48153 5.35146 1.51793 5.42939 1.59539C5.50686 1.67333 5.5456 1.76339 5.5456 1.86559C5.5456 1.96733 5.51153 2.05716 5.4434 2.13509C5.24926 2.32969 5.08173 2.54599 4.94079 2.78399C4.79986 3.02246 4.68553 3.27283 4.5978 3.53509C5.45366 3.68116 6.1609 4.08716 6.7195 4.75309C7.27856 5.41903 7.5581 6.18459 7.5581 7.04979C7.5581 8.04146 7.213 8.88239 6.5228 9.57259C5.83259 10.2628 4.99166 10.6079 3.99999 10.6079ZM3.99999 9.84979C4.77793 9.84979 5.43896 9.57749 5.9831 9.03289C6.5277 8.48876 6.79999 7.82773 6.79999 7.04979C6.79999 6.27186 6.5277 5.61083 5.9831 5.06669C5.43896 4.52209 4.77793 4.24979 3.99999 4.24979C3.22206 4.24979 2.56103 4.52209 2.01689 5.06669C1.47229 5.61083 1.19999 6.27186 1.19999 7.04979C1.19999 7.82773 1.47229 8.48876 2.01689 9.03289C2.56103 9.57749 3.22206 9.84979 3.99999 9.84979Z"
        fill={color}
      />
    </Svg>
  )
}

Nutrition.propTypes = {
  color: PropTypes.string,
}

Nutrition.defaultProps = {
  color: 'red',
}

export default Nutrition
